import { render } from "./dealerVisitDetails.vue?vue&type=template&id=4566a278&scoped=true"
import script from "./dealerVisitDetails.vue?vue&type=script&lang=js"
export * from "./dealerVisitDetails.vue?vue&type=script&lang=js"

import "./dealerVisitDetails.vue?vue&type=style&index=0&id=4566a278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4566a278"]])

export default __exports__